<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useMockupEditorStore } from '@/stores/mockupEditor'

const store = useMockupEditorStore()
const { hasAnimationLayers } = storeToRefs(store)

/** 无模型层时禁用保存，与导出区行为一致 */
const saveDisabled = computed(() => !hasAnimationLayers.value)
</script>

<template>
  <details class="acc" open>
    <summary class="sum">{{ store.tUi('inspectorProject.title') }}</summary>
    <div class="body">
      <div class="stack">
        <button type="button" class="btn" :disabled="saveDisabled" @click="store.saveProject">
          {{ store.tUi('inspectorProject.save') }}
        </button>
        <button type="button" class="btn" @click="store.loadProject">{{ store.tUi('inspectorProject.load') }}</button>
        <button type="button" class="btn danger" @click="store.resetProject">{{ store.tUi('inspectorProject.reset') }}</button>
      </div>
    </div>
  </details>
</template>

<style scoped>
.acc {
  border: 0;
}

.sum {
  cursor: pointer;
  list-style: none;
  font-size: 0.95rem;
  font-weight: 900;
  letter-spacing: -0.02em;
  color: #111;
  padding: 0.15rem 0;
}

.sum::-webkit-details-marker {
  display: none;
}

.body {
  padding-top: 0.65rem;
}

.stack {
  display: grid;
  gap: 0.5rem;
}

.btn {
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--im-border);
  background: #fff;
  color: #111;
  padding: 0.65rem 0.75rem;
  font-weight: 850;
  font-size: 0.875rem;
  cursor: pointer;
}

.btn:hover {
  background: var(--im-elevated);
}

.btn:focus-visible {
  outline: 2px solid #111;
  outline-offset: 2px;
}

.btn.danger {
  border-color: var(--im-danger);
  background: var(--im-danger);
  color: #fff;
}

.btn.danger:hover {
  filter: brightness(1.03);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
